import { downloadCsv as sharedDownloadCsv, toCsv as sharedToCsv } from '@/_shared';

import type { CsvRow } from './export-rows';

const defaultHeaders = ['Account #', 'Company Name', 'Invoice #', 'Amount', 'Amount Due', 'Status'];

export function toCsv(rows: CsvRow[], headers = defaultHeaders): string {
  return sharedToCsv(rows, headers);
}

export function downloadCsv(content: string, filename: string) {
  sharedDownloadCsv(content, filename);
}
